import { render } from "./GameAdminPane.vue?vue&type=template&id=c6079a3a&scoped=true"
import script from "./GameAdminPane.vue?vue&type=script&lang=js"
export * from "./GameAdminPane.vue?vue&type=script&lang=js"

import "./GameAdminPane.vue?vue&type=style&index=0&id=c6079a3a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6079a3a"]])

export default __exports__